// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MassCommunication.css */
.mass-communication-container {
    max-width: 800px;
    margin: 50px auto;
    padding: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    background-color: #f9f9f9;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .mass-communication-container h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 28px;
    font-weight: 600;
  }
  
  .form-group {
    margin-bottom: 25px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 10px;
    font-weight: bold;
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }
  
  .form-group select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    background-color: white;
    appearance: none; /* Remove default arrow */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 12px;
    transition: border-color 0.3s ease;
  }
  
  .form-group select:focus {
    border-color: #007bff;
    outline: none;
  }

  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s ease;
  }
  .form-group input:focus {
    border-color: #007bff;
    outline: none;
  }
  /* Styles for React Quill editor */
  .ql-editor {
    min-height: 250px;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    padding: 15px;
  }
  
  .ql-toolbar {
    border-radius: 8px 8px 0 0;
    border: 1px solid #ddd;
    background-color: #f9f9f9;
    padding: 8px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
  }
  
  .ql-container {
    border-radius: 0 0 8px 8px;
    border: 1px solid #ddd;
    font-size: 16px;
    background-color: #ffffff;
    
  }
  
  .ql-toolbar button:hover {
    background-color: #f0f0f0;
    border-color: #ccc;
  }
  .ql-toolbar button.ql-active {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
    
  }
  .ql-toolbar button {
    border-radius: 6px;
    
    background-color: #fff;
    padding: 6px 10px;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    height: 36px; /* Fixed height for better alignment */
    border: 2px solid white; /* White border */
  }
  .ql-toolbar .ql-picker {
    border-radius: 1px;
    border: 1px solid #ddd;
    background-color: #fff;
    align-items: center;
    align-content: center;
    transition: border-color 0.3s ease;
    height: 25px; /*Fixed height for better alignment */
    /* transition: border-color 0.3s ease; */
  } 

  .ql-toolbar .ql-picker:hover {
    border-color: #ccc;
  }
  
  .ql-toolbar .ql-picker.ql-expanded {
    border-color: #007bff;
  }
  
  .ql-toolbar .ql-picker-options {
    border-radius: 6px;
    border: 1px solid #ddd;
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .ql-toolbar .ql-picker-label {
    color: #333;
  }
  
  .ql-toolbar .ql-stroke {
    stroke: #333;
  }
  
  .ql-toolbar .ql-fill {
    fill: #333;
  }
  
  .ql-toolbar .ql-active .ql-stroke {
    stroke: #fff;
  }
  
  .ql-toolbar .ql-active .ql-fill {
    fill: #fff;
  }
  
  .ql-editor.ql-blank::before {
    color: #999;
    font-style: normal;
    font-size: 16px;
  }

  .upload-label {
    font-weight: bold;
    margin-bottom: 10px;
    display: block;
  }
  
  .send-button {
    background-color: #28a745;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    font-size: 16px;
  }
  /* Add white border to specific buttons */
.ql-toolbar button.ql-bold,
.ql-toolbar button.ql-italic,
.ql-toolbar button.ql-underline,
.ql-toolbar button.ql-strike
{
  border: 1px solid white; /* White border */
  align-items: center;
  align-content: center;
  margin-top: 5px;
}
.ql-toolbar button.ql-list[value="ordered"],
.ql-toolbar button.ql-list[value="bullet"]
{
    border: 1px solid white; /* White border */
    align-items: center;
    align-content: center;
    margin-top: 7px;
    gap: 20px;
  }
  .ql-toolbar .ql-picker.ql-color,
  .ql-toolbar .ql-picker.ql-background {
    border: 1px solid white; /* White border */
    align-items: center;
    align-content: center;
    margin-top: 5px;
    gap: 20px;
  }
  .ql-toolbar .ql-picker.ql-color .ql-picker-label,
  .ql-toolbar .ql-picker.ql-background .ql-picker-label {
  display: flex;
  align-items: center;
  justify-content: center;
}
  .send-button:hover {
    background-color: #218838;
  }

.template-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.template-toggle label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0;
}

.template-toggle input[type="checkbox"] {
  margin-right: 10px;
  width: 18px;
  height: 18px;
}

.editor-controls {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.preview-button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.preview-button:hover {
  background-color: #0056b3;
}

.html-editor {
  min-height: 400px;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
}

.email-preview {
  min-height: 400px;
  padding: 15px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow-y: auto;
}

.email-preview img {
  max-width: 100%;
  height: auto;
}

.send-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.email-status {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.email-status h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.email-status p {
  margin: 5px 0;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/MassCommunication.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB,EAAE,yBAAyB;IAC3C,yDAAof;IACpf,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;EACpC;EACA;IACE,qBAAqB;IACrB,aAAa;EACf;EACA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,yBAAyB;;EAE3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;;EAEb;EACA;IACE,kBAAkB;;IAElB,sBAAsB;IACtB,iBAAiB;IACjB,8DAA8D;IAC9D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY,EAAE,sCAAsC;IACpD,uBAAuB,EAAE,iBAAiB;EAC5C;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC;IAClC,YAAY,EAAE,qCAAqC;IACnD,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;EACjB;EACA,yCAAyC;AAC3C;;;;;EAKE,uBAAuB,EAAE,iBAAiB;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;;;IAGI,uBAAuB,EAAE,iBAAiB;IAC1C,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,SAAS;EACX;EACA;;IAEE,uBAAuB,EAAE,iBAAiB;IAC1C,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,SAAS;EACX;EACA;;EAEA,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;EACE;IACE,yBAAyB;EAC3B;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":["/* MassCommunication.css */\n.mass-communication-container {\n    max-width: 800px;\n    margin: 50px auto;\n    padding: 30px;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    background-color: #f9f9f9;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .mass-communication-container h2 {\n    text-align: center;\n    margin-bottom: 30px;\n    color: #333;\n    font-size: 28px;\n    font-weight: 600;\n  }\n  \n  .form-group {\n    margin-bottom: 25px;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 10px;\n    font-weight: bold;\n    color: #333;\n    font-weight: 600;\n    font-size: 16px;\n  }\n  \n  .form-group select {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 16px;\n    background-color: white;\n    appearance: none; /* Remove default arrow */\n    background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 12px;\n    transition: border-color 0.3s ease;\n  }\n  \n  .form-group select:focus {\n    border-color: #007bff;\n    outline: none;\n  }\n\n  .form-group input,\n  .form-group textarea {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.3s ease;\n  }\n  .form-group input:focus {\n    border-color: #007bff;\n    outline: none;\n  }\n  /* Styles for React Quill editor */\n  .ql-editor {\n    min-height: 250px;\n    font-size: 16px;\n    line-height: 1.6;\n    color: #333;\n    padding: 15px;\n  }\n  \n  .ql-toolbar {\n    border-radius: 8px 8px 0 0;\n    border: 1px solid #ddd;\n    background-color: #f9f9f9;\n    padding: 8px;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .ql-container {\n    border-radius: 0 0 8px 8px;\n    border: 1px solid #ddd;\n    font-size: 16px;\n    background-color: #ffffff;\n    \n  }\n  \n  .ql-toolbar button:hover {\n    background-color: #f0f0f0;\n    border-color: #ccc;\n  }\n  .ql-toolbar button.ql-active {\n    background-color: #007bff;\n    border-color: #007bff;\n    color: #fff;\n    \n  }\n  .ql-toolbar button {\n    border-radius: 6px;\n    \n    background-color: #fff;\n    padding: 6px 10px;\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    height: 36px; /* Fixed height for better alignment */\n    border: 2px solid white; /* White border */\n  }\n  .ql-toolbar .ql-picker {\n    border-radius: 1px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    align-items: center;\n    align-content: center;\n    transition: border-color 0.3s ease;\n    height: 25px; /*Fixed height for better alignment */\n    /* transition: border-color 0.3s ease; */\n  } \n\n  .ql-toolbar .ql-picker:hover {\n    border-color: #ccc;\n  }\n  \n  .ql-toolbar .ql-picker.ql-expanded {\n    border-color: #007bff;\n  }\n  \n  .ql-toolbar .ql-picker-options {\n    border-radius: 6px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .ql-toolbar .ql-picker-label {\n    color: #333;\n  }\n  \n  .ql-toolbar .ql-stroke {\n    stroke: #333;\n  }\n  \n  .ql-toolbar .ql-fill {\n    fill: #333;\n  }\n  \n  .ql-toolbar .ql-active .ql-stroke {\n    stroke: #fff;\n  }\n  \n  .ql-toolbar .ql-active .ql-fill {\n    fill: #fff;\n  }\n  \n  .ql-editor.ql-blank::before {\n    color: #999;\n    font-style: normal;\n    font-size: 16px;\n  }\n\n  .upload-label {\n    font-weight: bold;\n    margin-bottom: 10px;\n    display: block;\n  }\n  \n  .send-button {\n    background-color: #28a745;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    width: 100%;\n    font-size: 16px;\n  }\n  /* Add white border to specific buttons */\n.ql-toolbar button.ql-bold,\n.ql-toolbar button.ql-italic,\n.ql-toolbar button.ql-underline,\n.ql-toolbar button.ql-strike\n{\n  border: 1px solid white; /* White border */\n  align-items: center;\n  align-content: center;\n  margin-top: 5px;\n}\n.ql-toolbar button.ql-list[value=\"ordered\"],\n.ql-toolbar button.ql-list[value=\"bullet\"]\n{\n    border: 1px solid white; /* White border */\n    align-items: center;\n    align-content: center;\n    margin-top: 7px;\n    gap: 20px;\n  }\n  .ql-toolbar .ql-picker.ql-color,\n  .ql-toolbar .ql-picker.ql-background {\n    border: 1px solid white; /* White border */\n    align-items: center;\n    align-content: center;\n    margin-top: 5px;\n    gap: 20px;\n  }\n  .ql-toolbar .ql-picker.ql-color .ql-picker-label,\n  .ql-toolbar .ql-picker.ql-background .ql-picker-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n  .send-button:hover {\n    background-color: #218838;\n  }\n\n.template-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.template-toggle label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.template-toggle input[type=\"checkbox\"] {\n  margin-right: 10px;\n  width: 18px;\n  height: 18px;\n}\n\n.editor-controls {\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.preview-button {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease;\n}\n\n.preview-button:hover {\n  background-color: #0056b3;\n}\n\n.html-editor {\n  min-height: 400px;\n  font-family: monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  resize: vertical;\n}\n\n.email-preview {\n  min-height: 400px;\n  padding: 15px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow-y: auto;\n}\n\n.email-preview img {\n  max-width: 100%;\n  height: auto;\n}\n\n.send-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.email-status {\n  margin-top: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.email-status h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n}\n\n.email-status p {\n  margin: 5px 0;\n  color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
